import { ProductRefreshPreviewChromeSlot } from './ProductRefreshPreviewChromeSlot'
import { useShowProductRefreshToggle } from './useShowProductRefreshToggle'
import { registerDebugChromeSlot } from '../debug_tools/debugRegistry'

registerDebugChromeSlot({
  id: 'product-refresh-preview',
  removeBy: '2026-12-01',
  order: 10,
  useVisible: useShowProductRefreshToggle,
  Component: ProductRefreshPreviewChromeSlot,
})
